import React from "react";

export default function BrandStudioSignature() {
  return (
    <div className="flex items-center justify-center gap-2 pb-2 pt-2"
         data-testid="brand-studio-signature">
      <img
        src="/favicon-48x48.png"
        alt=""
        aria-hidden="true"
        width={18}
        height={18}
        style={{ display: "block" }}
      />
      <span className="text-[10.5px] leading-none" style={{ color: "#8B6F4B" }}>
        Anokina Studio · Brand Studio
      </span>
    </div>
  );
}
